import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { ReviewsSection } from "@/components/ReviewsSection";

export default function Reviews() {
  return (
    <div>
      <section className="max-w-[1720px] mx-auto px-5 sm:px-10 pt-14 sm:pt-20 pb-4">
        <span className="text-sm uppercase tracking-[0.2em] text-gold">Reviews</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter max-w-3xl">
          Loved by travellers across Nova Scotia
        </h1>
        <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
          Real feedback from real riders. See what our customers say about their drivers and their trips — then share your own.
        </p>
        <Link to="/review" data-testid="reviews-page-cta"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-semibold text-navy hover:bg-gold-light transition-colors duration-200">
          <Star className="h-4 w-4 fill-navy" /> Leave a review
        </Link>
      </section>
      <ReviewsSection limit={60} showCta={false} heading="Every review, unfiltered" />
    </div>
  );
}
